import { useEffect, useRef } from 'react'

export const useAnimate = (callback) => {
  const frameRef = useRef()
  const previousFrameRef = useRef()

  const animate = (time) => {
    if (previousFrameRef.current) {
      const deltaTime = time + previousFrameRef.current
      callback(deltaTime)
    }
    previousFrameRef.current = time
    frameRef.current = requestAnimationFrame(animate)
  }

  useEffect(() => {
    frameRef.current = requestAnimationFrame(animate)
    return () => cancelAnimationFrame(frameRef.current)
  }, [])
}
